import React from 'react';
import { ContainerSt } from "./style";

export const Container = ({ children, padding, className}) => {
    return (
        <ContainerSt className = {className} padding = {padding}>
            {children}
        </ContainerSt>
    );
}